import React, { useEffect, useMemo, useState } from 'react';
import Input from '../Common/Input';
import ReactSelect from 'react-select';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import InputMask from 'react-input-mask';


const deliveriesTypeList = [
    {
        id: 1,
        title: "حضوری"
    },
    {
        id: 2,
        title: "پیک"
    },
    {
        id: 3,
        title: "حضوری - پیک"
    }
]



const Form = ({ formik, orgAddress, setOrgAddress, setDeliveryType, deliveryType, rows, isEditMode }) => {

    const { readDataByFilter: readDataGroup } = useEntityCrud('Group/GetAllGroups')
    const { readData: readDataBusiness } = useEntityCrud('Business/GetAllBusiness')

    const [storageItemBusiness, setStorageItemBusiness] = useState([])
    const [storageItemGroup, setStorageItemGroup] = useState([])

    const [groupList, setGroupList] = useState([]);
    const [businessList, setBusinessList] = useState([]);

    const businessAll = useMemo(() => businessList
        .map(item => ({ value: item.id, label: item.title, isActive: item.isActive })));
    const groupAll = useMemo(() => groupList
        .map(item => ({ value: item.id, label: item.title, isActive: item.isActive })))

    useEffect(() => {
        readDataBusiness().then(res => {
            setBusinessList(res.data.result)
        });
    }, [])

    useEffect(() => {
        const postedData = {
            buisnessId: parseInt(localStorage.getItem("searchDetailsBuinessID")) ? parseInt(localStorage.getItem("searchDetailsBuinessID")) : orgAddress.buisnessId.value,
        };
        readDataGroup(postedData).then(res => {
            setGroupList(res.data.result)
        });
    }, [businessList, orgAddress.buisnessId.value])


    const handleChangeBusiness = (value) => {
        localStorage.removeItem("searchDetailsBuinessID");
        localStorage.removeItem("searchDetailsGroupID");
        setOrgAddress(prevState => ({ ...prevState, groupId: "" }))
        setOrgAddress(prevState => ({ ...prevState, buisnessId: value }))
        setStorageItemGroup({
            value: "",
            label: ""
        })
    }

    const handleChangeGroup = (value) => {
        localStorage.removeItem("searchDetailsBuinessID");
        localStorage.removeItem("searchDetailsGroupID");
        setOrgAddress(prevState => ({ ...prevState, groupId: value }))
    }

    useEffect(() => {
        const searchDetailsBusinessId = parseInt(localStorage.getItem("searchDetailsBuinessID"));
        setStorageItemBusiness({
            value: businessAll?.find(it => it.value === searchDetailsBusinessId),
            label: businessAll?.find(it => it.value === searchDetailsBusinessId)?.label
        })
        const searchDetailsGroupId = parseInt(localStorage.getItem("searchDetailsGroupID"));
        setStorageItemGroup({
            value: groupAll?.find(it => it.value === searchDetailsGroupId),
            label: groupAll?.find(it => it.value === searchDetailsGroupId)?.label
        })
    }, [localStorage.getItem("searchDetailsBuinessID"), localStorage.getItem("searchDetailsGroupID"), businessList, groupList])



    return (
        <form onSubmit={formik.handleSubmit}>

            <div class="alert alert-info" role="alert">
                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-hidden="true">×</button>
                <i class="fa fa-bell-o me-2" aria-hidden="true"></i>
                در قسمت ویرایش پیک , فقط      <span className='mx-3'> شماره پلاک</span> قابل بروزرسانی است.
            </div>

            <div className="row">
                <div className="col-md-3">
                    <label>
                        کسب و کار
                    </label>
                    <ReactSelect label="   کسب و کار"
                        options={businessAll.filter(item => item.isActive === true)}
                        value={businessAll.length === 1 ? businessAll[0] : orgAddress.buisnessId}

                        onChange={handleChangeBusiness}
                        placeholder="انتخاب کنید"
                        name="buisnessId"
                        isDisabled={isEditMode ? true : false}
                    />
                </div>
   
                <div className="col-md-6">
                    <Input label="توضیحات" name="description" formik={formik} />
                </div>
                <div className="col-md-3">
                    <div className="form-group">
                        <label>شماره پلاک</label>

                        <InputMask mask="999" className="form-control ltr-input mb-1"
                            value={formik.values.delivervehicle1}
                            onChange={e => formik.setFieldValue("delivervehicle1", e.target.value)}
                            style={{ width: "40%", float: "left" }} />

                        <InputMask mask="99999" className="form-control ltr-input"
                            value={formik.values.delivervehicle2}
                            onChange={e => formik.setFieldValue("delivervehicle2", e.target.value)}
                            style={{ width: "70%", float: "left" }} />

                    </div>
                </div>
            </div>
            <hr />
            <div className="row">

                <div className="col-md-3">
                    <Input label=" نام " name="name" required={true} formik={formik} disabled={isEditMode ? true : false} />
                </div>
                <div className="col-md-3">
                    <Input label=" نام خانوادگی " name="lastName" required={true} formik={formik} disabled={isEditMode ? true : false} />
                </div>
                <div className="col-md-3">
                    <Input label=" کد ملی " name="nationalCode" required={true} formik={formik} disabled={isEditMode ? true : false} />
                </div>
                <div className="col-md-3">
                    <Input label="تلفن" name="phone" required={true} formik={formik} disabled={isEditMode ? true : false} />
                </div>
                <div className="col-md-3">
                    <Input label="شماره همراه" name="cellphone" required={true} formik={formik} disabled={isEditMode ? true : false} />
                </div>

            </div>

            <button className="btn btn-success mt-4" id="btn-submit-form">ذخیره اطلاعات</button>
        </form>
    );
}

export default Form;